import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=337ac676&scoped=true&lang=pug"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"
import style0 from "./Popover.vue?vue&type=style&index=0&id=337ac676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ac676",
  null
  
)

export default component.exports